import { apiPostNonAuth, apiPostAuth, apiGetAuth, apiPutNonAuth, apiPutAuth } from '@/utils/api'
import { API_AUTH, API_FCM, API_MENU } from '@/utils/api-url'
import { logoutUser, setCookie, setCookieProfile, setStorageRole, setUserEmployee } from '@/utils/auth'
import {
  notificationSuccess,
  notificationDanger
} from '@/utils/notification'
import router, { getDefaultAuthenticatedRoute } from '@/router'
import { appFirebase } from '@/configs/firebase'
import { getMessaging, getToken } from 'firebase/messaging'

const VAPID_KEY = `${process.env.VUE_APP_FIREBASE_VAPID_KEY}`

const refreshUserEmployeeCookie = (profile) => {
  switch(profile?.role?.name?.toUpperCase()) {
  case 'COMPANY':
    if(profile?.user_employee != null) {
      setUserEmployee(profile.user_employee)
    }
    break
  case 'USER':
    if(profile?.user_employee != null) {
      setUserEmployee(profile.user_employee?.company_employee)
    }
    break
  default:
    setUserEmployee({
      company: {
        id: '',
        generate_invoice: false,
        subdivision: true
      }
    })
    break
  }
}
const state = {
  login_response: {},
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loading: false,
    loadingPopUp: false
  }
}

const mutations = {
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_LOGIN_RESPONSE": (state, payload) => {
    state.login_response = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  }
}

const actions = {
  async login(context, payload) {
    let sessionCreated = false
    try {
      const { redirect, ...credentials } = payload
      const response = await apiPostNonAuth(API_AUTH.LOGIN, credentials)
      if(response?.data?.status == 200) {
        context.commit('SET_LOGIN_RESPONSE', response.data.data)
        const token = response.data.data?.token
        setCookie(token)
        sessionCreated = true
        const res = await apiGetAuth(API_AUTH.GET_USER_PROFILE)
        setCookieProfile(res?.data?.data)

        // Get Menu by Token //
        const responseMenuByToken = await apiGetAuth(API_MENU.LIST_BY_TOKEN, { page: 1, limit: 20 })
        const roleManagements = responseMenuByToken?.data?.data
        if(!Array.isArray(roleManagements)) {
          throw new Error('Invalid menu response')
        }
        setStorageRole(roleManagements)

        refreshUserEmployeeCookie(res?.data?.data)

        const isLocalRedirect = typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')

        const destination = isLocalRedirect
          ? redirect
          : getDefaultAuthenticatedRoute(res?.data?.data, roleManagements)

        await router.push(destination)

        notificationSuccess('Login Berhasil')

        // Registered Key FCM Device //
        if (!appFirebase) return
        const messaging = getMessaging(appFirebase)
        getToken(messaging, { vapidKey: `${VAPID_KEY}` })
          .then(async (tokenFirebase) => {
            if (tokenFirebase) {
              try {
                const response = await apiPostAuth(API_FCM.ADD_FCM, { category: 'FCM', token: `${tokenFirebase}`})
                return response?.data
              } catch (error) {
                return error?.response?.data
              }
            } else {
              notificationDanger('No registration token available. Request permission to generate one')
            }
          }).catch((err) => {
            notificationDanger(err)
          })
      }
    } catch (err) {
      if(sessionCreated) logoutUser()
      if(err.code === 'ECONNABORTED') {
        notificationDanger('Server tidak merespon, silakan coba lagi')
      } else {
        notificationDanger(err)
      }
    }
  },
  async getUserProfile(context, payload) {
    try {
      const response = await apiGetAuth(API_AUTH.GET_USER_PROFILE, payload)
      setCookieProfile(response?.data?.data)
      refreshUserEmployeeCookie(response?.data?.data)
      try {
        const responseMenuByToken = await apiGetAuth(API_MENU.LIST_BY_TOKEN, { page: 1, limit: 20 })
        if(Array.isArray(responseMenuByToken?.data?.data)) {
          setStorageRole(responseMenuByToken.data.data)
        }
      } catch (errMenu) {
        // ignore menu refresh failure, keep existing localStorage
      }
      return response?.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async forgotPassword(context, payload) {
    try {
      const response = await apiPostNonAuth(API_AUTH.FORGOT_PASSWORD, payload)
      if(response.status == 200) {
        notificationSuccess('Email berhasil dikirim')
        setTimeout(() => {
          router.push('/login')
        }, 1000)
      }     
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', { loading: false })
      notificationDanger(error)
    }
  },
  async resetPassword(context, payload) {
    try {
      const response = await apiPutNonAuth(API_AUTH.FORGOT_PASSWORD, payload)
      if(response.status == 200) {
        notificationSuccess('Buat Password Berhasil')
        router.push('/login')
      }
      return response.data
    } catch (err) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', { loading: false })
      notificationDanger(err)
    }
  },
  async changePassword(context, payload) {
    try {
      const response = await apiPostAuth(API_AUTH.CHANGE_PASSWORD, payload)
      return response.data
    } catch (err) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', { loading: false })
      notificationDanger(err)
    }
  },
  async changePasswordProfile(context, payload) {
    try {
      const response = await apiPutAuth(API_AUTH.CHANGE_PASSWORD_PROFILE, payload)
      return response
    } catch (err) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', { loading: false })
      const errorMessage = err?.response?.data?.message

      if(errorMessage === 'crypto/bcrypt: hashedPassword is not the hash of the given password wrong password'){
        notificationDanger('Kata sandi tidak valid')
      } else{
        notificationDanger(err)
      }
      return err?.response?.data
    }
  },
  async emailActivation(context, payload) {
    try {
      const response = await apiPostAuth(API_AUTH.EMAIL_ACTIVATION, payload)
      return response.data
    } catch (err) {
      notificationDanger(err)
    }
  },
  async logout() {
    try {
      notificationSuccess('Logout Berhasil')
      setTimeout(() => {
        logoutUser()
      }, 1000)
    } catch (err) {
      notificationDanger(err)
    }
  }
}

const getters = {
  get_login_response: state => {
    return state.login_response
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
